// extracted by mini-css-extract-plugin
export default {"ShedDogResults":"ShedDogResults_ShedDogResults__ltASq","row":"ShedDogResults_row__GPHd+"};